export interface BuildGoogleCalendarUrlOptions {
  startTimeInMS: number;
  durationInMinutes: number;
  location?: string | null;
  videoURL?: string | null;
  externalVideoURL?: string | null;
  healthieZoomJoinURL?: string | null;
  displayTitle?: string | null;
  title: string;
  displayDescription?: string | null;
}

export const buildGoogleCalendarUrl = (event: BuildGoogleCalendarUrlOptions): string => {
  const startDate = new Date(event.startTimeInMS);
  const endDate = new Date(event.startTimeInMS + event.durationInMinutes * 60 * 1000);

  const formatForGCal = (date: Date) =>
    date
      .toISOString()
      .replace(/[-:]/g, "")
      .replace(/\.\d{3}/, "");

  let location = event.location ?? "";
  if (event.videoURL) {
    location = event.videoURL;
  } else if (event.externalVideoURL) {
    location = event.externalVideoURL;
  } else if (event.healthieZoomJoinURL) {
    location = event.healthieZoomJoinURL;
  }

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.displayTitle ?? event.title,
    dates: `${formatForGCal(startDate)}/${formatForGCal(endDate)}`,
    details: event.displayDescription ?? "",
    location,
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};
